module.exports = __webpack_public_path__ + "img/flow_2.360712c2.png";